<template>
  <div class="floating-container">
    <div class="floating-button" @click="openWhatsapp">
      <svg width="133" height="40" xmlns="http://www.w3.org/2000/svg" fill="none">
        <g>
          <title>Layer 1</title>
          <path
            fill="#25D366"
            opacity="undefined"
            d="m0,8c0,-4.34703 2.56234,-8 5.61153,-8l121.34925,0c3.04919,0 5.61153,3.65297 5.61153,8l0,24c0,4.34703 -2.56234,8 -5.61153,8l-121.34925,0c-3.04919,0 -5.61153,-3.65297 -5.61153,-8l0,-24z"
            id="svg_1"
            stroke="null"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="m27.7462,8.9474c2.9024,0.014 5.7034,1.1536 7.7986,3.1621c2.1456,2.057 3.3822,4.8152 3.4903,7.7856c0.1056,2.9007 -0.9071,5.7501 -2.8279,7.9262c-2.1067,2.3867 -5.0371,3.7574 -8.2021,3.8483a11.3615,11.3615 0 0 1 -0.325,0.0046c-1.7054,0 -3.3949,-0.3845 -4.9252,-1.1209l-5.9481,1.323a0.0874,0.0874 0 0 1 -0.1033,-0.0974l1.0048,-6.0144c-0.8575,-1.5668 -1.3361,-3.3321 -1.3877,-5.1278c-0.087,-3.0341 1.0127,-5.9203 3.0966,-8.1273c2.1606,-2.2882 5.1111,-3.562 8.2727,-3.562l0.0563,0zm-0.0633,1.9717a9.576,9.576 0 0 0 -0.2728,0.0039c-5.1765,0.1485 -9.2671,4.4807 -9.1186,9.6572c0.0454,1.5806 0.4907,3.1322 1.2878,4.4869l0.173,0.2936l-0.7445,4.0812l4.0387,-0.9533l0.305,0.1587c1.3307,0.6924 2.8218,1.0553 4.3283,1.0553c0.0895,0 0.1792,-0.0013 0.2687,-0.0039c5.1766,-0.1484 9.2672,-4.4806 9.1187,-9.6571c-0.1459,-5.0851 -4.3294,-9.1225 -9.3843,-9.1225zm-3.9285,3.9024c0.1899,0.0059 0.3802,0.0113 0.5462,0.0235c0.2029,0.0146 0.4275,0.031 0.6265,0.5128c0.2362,0.5721 0.747,2.0004 0.8139,2.1453c0.0669,0.1449 0.1093,0.313 0.0084,0.5007c-0.1009,0.1873 -0.1521,0.3049 -0.2995,0.467c-0.1477,0.1623 -0.3111,0.3628 -0.4431,0.4867c-0.1474,0.1379 -0.3006,0.2879 -0.143,0.5785c0.1575,0.2907 0.701,1.2424 1.5255,2.0249c1.0596,1.0056 1.9093,1.3374 2.2468,1.4948c0.1218,0.0569 0.223,0.0839 0.3114,0.0839c0.1214,0 0.2185,-0.0509 0.3112,-0.1448c0.1776,-0.18 0.712,-0.8036 0.937,-1.0905c0.1177,-0.1501 0.2243,-0.2033 0.34,-0.2033c0.0926,0 0.1911,0.0341 0.3061,0.08c0.2584,0.1032 1.639,0.8366 1.9198,0.9881c0.2808,0.1514 0.4686,0.2287 0.5363,0.3497c0.0676,0.1216 0.05,0.6927 -0.2081,1.3517c-0.2581,0.6591 -1.4419,1.2661 -1.9662,1.2975c-0.1535,0.0093 -0.3045,0.0307 -0.501,0.0307c-0.4751,0 -1.2159,-0.1251 -2.8986,-0.8498c-2.8631,-1.2329 -4.6017,-4.2625 -4.7385,-4.4571c-0.1365,-0.1949 -1.1167,-1.5831 -1.0736,-2.9873c0.0431,-1.404 0.801,-2.0718 1.0712,-2.3493c0.259,-0.2661 0.5558,-0.334 0.7474,-0.334l0.0239,0.0003z"
            fill="#fff"
            id="svg_2"
          />
          <path
            d="m2.76475,12.6498zm57.0151,6.636l2.688,-9.996l-2.156,0l-1.638,6.888l-0.028,0l-1.708,-6.888l-2.058,0l-1.736,6.804l-0.028,0l-1.582,-6.804l-2.198,0l2.646,9.996l2.226,0l1.666,-6.804l0.028,0l1.694,6.804l2.184,0zm3.491,-9.996l0,9.996l1.988,0l0,-3.794c0,-0.7373 0.121,-1.2647 0.364,-1.582c0.242,-0.3267 0.634,-0.49 1.176,-0.49c0.476,0 0.807,0.1493 0.994,0.448c0.186,0.2893 0.28,0.7327 0.28,1.33l0,4.088l1.988,0l0,-4.452c0,-0.448 -0.042,-0.854 -0.126,-1.218c-0.075,-0.3733 -0.21,-0.686 -0.406,-0.938c-0.196,-0.2613 -0.467,-0.462 -0.812,-0.602c-0.336,-0.1493 -0.77,-0.224 -1.302,-0.224c-0.374,0 -0.756,0.098 -1.148,0.294c-0.392,0.1867 -0.714,0.49 -0.966,0.91l-0.042,0l0,-3.766l-1.988,0zm8.215,4.984c0.028,-0.4667 0.144,-0.854 0.35,-1.162a2.374,2.374 0 0 1 0.784,-0.742c0.317,-0.1867 0.672,-0.3173 1.064,-0.392c0.401,-0.084 0.802,-0.126 1.204,-0.126c0.364,0 0.732,0.028 1.106,0.084c0.373,0.0467 0.714,0.1447 1.022,0.294c0.308,0.1493 0.56,0.3593 0.756,0.63c0.196,0.2613 0.294,0.6113 0.294,1.05l0,3.766c0,0.3267 0.018,0.6393 0.056,0.938c0.037,0.2987 0.102,0.5227 0.196,0.672l-2.016,0c-0.038,-0.112 -0.07,-0.224 -0.098,-0.336a4.5069,4.5069 0 0 1 -0.042,-0.364c-0.318,0.3267 -0.691,0.5553 -1.12,0.686c-0.43,0.1307 -0.868,0.196 -1.316,0.196c-0.346,0 -0.668,-0.042 -0.966,-0.126c-0.299,-0.084 -0.56,-0.2147 -0.784,-0.392c-0.224,-0.1773 -0.402,-0.4013 -0.532,-0.672c-0.122,-0.2707 -0.182,-0.5927 -0.182,-0.966c0,-0.4107 0.07,-0.7467 0.21,-1.008c0.149,-0.2707 0.336,-0.4853 0.56,-0.644c0.233,-0.1587 0.494,-0.2753 0.784,-0.35c0.298,-0.084 0.597,-0.1493 0.896,-0.196c0.298,-0.0467 0.592,-0.084 0.882,-0.112c0.289,-0.028 0.546,-0.07 0.77,-0.126c0.224,-0.056 0.401,-0.1353 0.532,-0.238c0.13,-0.112 0.191,-0.2707 0.182,-0.476c0,-0.2147 -0.038,-0.3827 -0.112,-0.504c-0.066,-0.1307 -0.159,-0.2287 -0.28,-0.294c-0.112,-0.0747 -0.248,-0.1213 -0.406,-0.14c-0.15,-0.028 -0.313,-0.042 -0.49,-0.042c-0.392,0 -0.7,0.084 -0.924,0.252c-0.224,0.168 -0.355,0.448 -0.392,0.84l-1.988,0zm4.592,1.47c-0.084,0.0747 -0.192,0.1353 -0.322,0.182c-0.122,0.0373 -0.257,0.07 -0.406,0.098c-0.14,0.028 -0.29,0.0513 -0.448,0.07a8.257,8.257 0 0 0 -0.476,0.07c-0.15,0.028 -0.299,0.0653 -0.448,0.112c-0.14,0.0467 -0.266,0.112 -0.378,0.196c-0.103,0.0747 -0.187,0.1727 -0.252,0.294c-0.066,0.1213 -0.098,0.2753 -0.098,0.462c0,0.1773 0.032,0.3267 0.098,0.448a0.8049,0.8049 0 0 0 0.266,0.294c0.112,0.0653 0.242,0.112 0.392,0.14c0.149,0.028 0.303,0.042 0.462,0.042c0.392,0 0.695,-0.0653 0.91,-0.196c0.214,-0.1307 0.373,-0.2847 0.476,-0.462c0.102,-0.1867 0.163,-0.3733 0.182,-0.56c0.028,-0.1867 0.042,-0.336 0.042,-0.448l0,-0.742zm6.051,-3.696l0,-2.17l-1.988,0l0,2.17l-1.204,0l0,1.33l1.204,0l0,4.27c0,0.364 0.06,0.658 0.182,0.882c0.121,0.224 0.284,0.3967 0.49,0.518c0.214,0.1213 0.457,0.2007 0.728,0.238c0.28,0.0467 0.574,0.07 0.882,0.07c0.196,0 0.396,-0.0047 0.602,-0.014c0.205,-0.0093 0.392,-0.028 0.56,-0.056l0,-1.54a2.8181,2.8181 0 0 1 -0.294,0.042c-0.103,0.0093 -0.21,0.014 -0.322,0.014c-0.336,0 -0.56,-0.056 -0.672,-0.168c-0.112,-0.112 -0.168,-0.336 -0.168,-0.672l0,-3.584l1.456,0l0,-1.33l-1.456,0zm3.941,4.886l-1.89,0c0.019,0.4853 0.126,0.8913 0.322,1.218c0.206,0.3173 0.462,0.574 0.77,0.77c0.318,0.196 0.677,0.336 1.078,0.42c0.402,0.084 0.812,0.126 1.232,0.126c0.411,0 0.812,-0.042 1.204,-0.126c0.402,-0.0747 0.756,-0.21 1.064,-0.406a2.248,2.248 0 0 0 0.742,-0.77c0.196,-0.3267 0.294,-0.728 0.294,-1.204c0,-0.336 -0.065,-0.616 -0.196,-0.84c-0.13,-0.2333 -0.303,-0.4247 -0.518,-0.574c-0.214,-0.1587 -0.462,-0.2847 -0.742,-0.378a7.8493,7.8493 0 0 0 -0.84,-0.238a33.371,33.371 0 0 0 -0.826,-0.182c-0.27,-0.056 -0.513,-0.1167 -0.728,-0.182c-0.205,-0.0747 -0.373,-0.168 -0.504,-0.28c-0.13,-0.112 -0.196,-0.2567 -0.196,-0.434c0,-0.1493 0.038,-0.266 0.112,-0.35c0.075,-0.0933 0.164,-0.1633 0.266,-0.21a1.156,1.156 0 0 1 0.364,-0.084c0.131,-0.0187 0.252,-0.028 0.364,-0.028c0.355,0 0.663,0.07 0.924,0.21c0.262,0.1307 0.406,0.3873 0.434,0.77l1.89,0c-0.037,-0.448 -0.154,-0.8167 -0.35,-1.106c-0.186,-0.2987 -0.424,-0.5367 -0.714,-0.714c-0.289,-0.1773 -0.62,-0.3033 -0.994,-0.378c-0.364,-0.0747 -0.742,-0.112 -1.134,-0.112c-0.392,0 -0.774,0.0373 -1.148,0.112c-0.373,0.0653 -0.709,0.1867 -1.008,0.364c-0.298,0.168 -0.541,0.4013 -0.728,0.7c-0.177,0.2987 -0.266,0.6813 -0.266,1.148c0,0.3173 0.066,0.588 0.196,0.812c0.131,0.2147 0.304,0.3967 0.518,0.546c0.215,0.14 0.458,0.2567 0.728,0.35c0.28,0.084 0.565,0.1587 0.854,0.224c0.71,0.1493 1.26,0.2987 1.652,0.448c0.402,0.1493 0.602,0.3733 0.602,0.672c0,0.1773 -0.042,0.3267 -0.126,0.448c-0.084,0.112 -0.191,0.2053 -0.322,0.28c-0.121,0.0653 -0.261,0.1167 -0.42,0.154a2.351,2.351 0 0 1 -0.434,0.042a2.358,2.358 0 0 1 -0.574,-0.07c-0.177,-0.0467 -0.336,-0.1167 -0.476,-0.21a1.3646,1.3646 0 0 1 -0.35,-0.378c-0.084,-0.1587 -0.126,-0.3453 -0.126,-0.56zm8.71,-1.512l1.302,-3.668l0.028,0l1.26,3.668l-2.59,0zm0.21,-6.132l-3.78,9.996l2.212,0l0.784,-2.226l3.738,0l0.756,2.226l2.282,0l-3.738,-9.996l-2.254,0zm10.298,8.694c-0.317,0 -0.588,-0.0653 -0.812,-0.196c-0.224,-0.1307 -0.406,-0.2987 -0.546,-0.504c-0.131,-0.2147 -0.229,-0.462 -0.294,-0.742a4.3441,4.3441 0 0 1 -0.084,-0.854c0,-0.2987 0.028,-0.588 0.084,-0.868c0.056,-0.28 0.149,-0.5273 0.28,-0.742c0.14,-0.2147 0.317,-0.3873 0.532,-0.518c0.224,-0.14 0.499,-0.21 0.826,-0.21c0.317,0 0.583,0.07 0.798,0.21c0.224,0.1307 0.406,0.308 0.546,0.532c0.14,0.2147 0.238,0.462 0.294,0.742c0.065,0.28 0.098,0.5647 0.098,0.854s-0.028,0.574 -0.084,0.854c-0.056,0.28 -0.154,0.5273 -0.294,0.742c-0.131,0.2053 -0.308,0.3733 -0.532,0.504c-0.215,0.1307 -0.485,0.196 -0.812,0.196zm-3.654,-5.936l0,9.772l1.988,0l0,-3.43l0.028,0c0.243,0.3547 0.551,0.6253 0.924,0.812c0.383,0.1773 0.798,0.266 1.246,0.266c0.532,0 0.994,-0.1027 1.386,-0.308c0.401,-0.2053 0.733,-0.4807 0.994,-0.826c0.271,-0.3453 0.471,-0.742 0.602,-1.19c0.131,-0.448 0.196,-0.9147 0.196,-1.4c0,-0.5133 -0.065,-1.0033 -0.196,-1.47c-0.131,-0.476 -0.331,-0.8913 -0.602,-1.246c-0.271,-0.3547 -0.611,-0.6393 -1.022,-0.854c-0.411,-0.2147 -0.901,-0.322 -1.47,-0.322c-0.448,0 -0.859,0.0887 -1.232,0.266s-0.681,0.462 -0.924,0.854l-0.028,0l0,-0.924l-1.89,0zm12.213,5.936c-0.318,0 -0.588,-0.0653 -0.812,-0.196c-0.224,-0.1307 -0.406,-0.2987 -0.546,-0.504c-0.131,-0.2147 -0.229,-0.462 -0.294,-0.742a4.3441,4.3441 0 0 1 -0.084,-0.854c0,-0.2987 0.028,-0.588 0.084,-0.868c0.056,-0.28 0.149,-0.5273 0.28,-0.742c0.14,-0.2147 0.317,-0.3873 0.532,-0.518c0.224,-0.14 0.499,-0.21 0.826,-0.21c0.317,0 0.583,0.07 0.798,0.21c0.224,0.1307 0.406,0.308 0.546,0.532c0.14,0.2147 0.238,0.462 0.294,0.742c0.065,0.28 0.098,0.5647 0.098,0.854s-0.028,0.574 -0.084,0.854c-0.056,0.28 -0.154,0.5273 -0.294,0.742c-0.131,0.2053 -0.308,0.3733 -0.532,0.504c-0.215,0.1307 -0.486,0.196 -0.812,0.196zm-3.654,-5.936l0,9.772l1.988,0l0,-3.43l0.028,0c0.242,0.3547 0.55,0.6253 0.924,0.812c0.382,0.1773 0.798,0.266 1.246,0.266c0.532,0 0.994,-0.1027 1.386,-0.308c0.401,-0.2053 0.732,-0.4807 0.994,-0.826c0.27,-0.3453 0.471,-0.742 0.602,-1.19c0.13,-0.448 0.196,-0.9147 0.196,-1.4c0,-0.5133 -0.066,-1.0033 -0.196,-1.47c-0.131,-0.476 -0.332,-0.8913 -0.602,-1.246c-0.271,-0.3547 -0.612,-0.6393 -1.022,-0.854c-0.411,-0.2147 -0.901,-0.322 -1.47,-0.322c-0.448,0 -0.859,0.0887 -1.232,0.266c-0.374,0.1773 -0.682,0.462 -0.924,0.854l-0.028,0l0,-0.924l-1.89,0z"
            fill="#fff"
            id="svg_3"
            stroke="null"
          />
          <text
            fill="#ffffff"
            x="51.12943"
            y="35.40942"
            id="svg_4"
            stroke-width="0"
            font-size="15"
            font-family="'Inter'"
            text-anchor="start"
            xml:space="preserve"
            stroke="null"
            transform="matrix(0.988636 0 0 1 -0.480487 -0.357137)"
          >
            Iniciar chat
          </text>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingButton",
  props: ["phone"],
  methods: {
    openWhatsapp: function () {
      window.open("https://wa.me/" + this.phone);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto");
@-webkit-keyframes come-in {
  0% {
    -webkit-transform: translatey(100px);
    transform: translatey(100px);
    opacity: 0;
  }
  30% {
    -webkit-transform: translateX(-50px) scale(0.4);
    transform: translateX(-50px) scale(0.4);
  }
  70% {
    -webkit-transform: translateX(0px) scale(1.2);
    transform: translateX(0px) scale(1.2);
  }
  100% {
    -webkit-transform: translatey(0px) scale(1);
    transform: translatey(0px) scale(1);
    opacity: 1;
  }
}
@keyframes come-in {
  0% {
    -webkit-transform: translatey(100px);
    transform: translatey(100px);
    opacity: 0;
  }
  30% {
    -webkit-transform: translateX(-50px) scale(0.4);
    transform: translateX(-50px) scale(0.4);
  }
  70% {
    -webkit-transform: translateX(0px) scale(1.2);
    transform: translateX(0px) scale(1.2);
  }
  100% {
    -webkit-transform: translatey(0px) scale(1);
    transform: translatey(0px) scale(1);
    opacity: 1;
  }
}

.floating-container {
  position: fixed;
  width: 150px;
  height: 70px;
  bottom: 0;
  left: 0;
  margin: 25px 25px;
}
.floating-container:hover {
  height: 300px;
}
.floating-container:hover .floating-button {
  -webkit-transform: translatey(5px);
  transform: translatey(5px);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.floating-container:hover .element-container .float-element:nth-child(1) {
  -webkit-animation: come-in 0.4s forwards 0.2s;
  animation: come-in 0.4s forwards 0.2s;
}
.floating-container:hover .element-container .float-element:nth-child(2) {
  -webkit-animation: come-in 0.4s forwards 0.4s;
  animation: come-in 0.4s forwards 0.4s;
}
.floating-container:hover .element-container .float-element:nth-child(3) {
  -webkit-animation: come-in 0.4s forwards 0.6s;
  animation: come-in 0.4s forwards 0.6s;
}
.floating-container .floating-button {
  position: absolute;
  width: 150px;
  height: 60px;
  bottom: 0;
  border-radius: 50%;
  left: 0;
  right: 0;
  margin: auto;
  line-height: 70px;
  text-align: center;
  font-size: 23px;
  z-index: 100;
  box-shadow: 0 10px 25px -5px rgba(44, 179, 240, 0);
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.floating-container .float-element {
  position: relative;
  display: block;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin: 15px auto;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  z-index: 0;
  opacity: 0;
  -webkit-transform: translateY(100px);
  transform: translateY(100px);
}
.floating-container .float-element .material-icons {
  vertical-align: middle;
  font-size: 16px;
}
.floating-container .float-element:nth-child(1) {
  background: #42a5f5;
  box-shadow: 0 20px 20px -10px rgba(66, 165, 245, 0.5);
}
.floating-container .float-element:nth-child(2) {
  background: #4caf50;
  box-shadow: 0 20px 20px -10px rgba(76, 175, 80, 0.5);
}
.floating-container .float-element:nth-child(3) {
  background: #ff9800;
  box-shadow: 0 20px 20px -10px rgba(255, 152, 0, 0.5);
}
</style>
